<template>
  <div class="modal-overlay" @click="$emit('close-insurance-modal')">
    <div class="card" @click.stop>
      <div class="card-header">
        <i class="fa fa-medkit text-primary me-2" />{{
          props.insurance.id != null ? "Edit Insurance" : "New Insurance"
        }}
      </div>
      <hr class="horizontal dark m-0" />

      <el-form
        ref="insuranceFormRef"
        :model="insuranceForm"
        :rules="rules"
        label-width="120px"
        size=""
        status-icon
        :scroll-to-error="true"
        label-position="top"
        :hide-required-asterisk="true"
      >
        <div class="card-body">
          <div class="mb-3">
            <el-form-item label="Insurance Name" prop="name">
              <el-input v-model="insuranceForm.name" />
            </el-form-item>
          </div>
          <div class="mt-4">
            <el-checkbox
              v-model="insuranceForm.restricted"
              label="Restricted use?"
              border
            />
          </div>
          <div class="mb-3">
            <el-form-item label="Insurance Policy Number" prop="name">
              <el-input v-model="insuranceForm.policy_number" />
            </el-form-item>
          </div>
          <div class="mb-3">
            <el-form-item label="Phone Number" prop="phone">
              <el-input v-model="insuranceForm.contact_phone" />
            </el-form-item>
          </div>

          <div class="mb-3">
            <el-form-item label="Email" prop="email">
              <el-input v-model="insuranceForm.contact_email" />
            </el-form-item>
          </div>
          <div class="mb-3">
            <el-form-item label="Contact Address" prop="address">
              <el-input v-model="insuranceForm.contact_address" />
            </el-form-item>
          </div>

          <div class="mb-3">
            <el-form-item label="Description" prop="description">
              <el-input v-model="insuranceForm.description" type="textarea" />
            </el-form-item>
          </div>
        </div>
        <div class="card--footer">
          <button
            class="btn mb-0 btn-danger btn-xs"
            @click="$emit('close-modal')"
          >
            Cancel
          </button>
          <el-button
            type="success"
            :loading="isLoading"
            @click="submitForm(insuranceFormRef)"
            >Submit</el-button
          >
        </div>
      </el-form>
    </div>
    <div class="close bg-danger" @click="$emit('close-modal')">
      <i class="fa fa-times" />
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { createInsurance, updateInsurance } from "../../api/services/services";
import { ElNotification } from "element-plus";
const insuranceFormRef = ref();
const isLoading = ref(false);
export default {
  name: "add-insurance",
  props: {
    insurance: {
      type: Object,
      required: false,
    },
  },
  setup(props, { emit }) {
    console.log(props?.insurance);
    const insuranceForm = reactive({
      id: props?.insurance?.id || 0,
      name: props?.insurance?.name || "",
      contact_phone: props?.insurance?.contact_phone || "",
      contact_email: props?.insurance?.contact_email || "",
      contact_address: props?.insurance?.contact_address || "",
      description: props?.insurance?.description || "",
      policy_number: props?.insurance?.policy_number || "",
      restricted: props?.insurance?.restricted == 1 || false,
      status: props?.insurance?.status || 1,
    });

    const rules = reactive({
      contact_email: [
        {
          required: false,
          message: "Please input email address",
          trigger: "blur",
        },
        {
          type: "email",
          message: "Please input correct email address",
          trigger: ["blur", "change"],
        },
      ],
      name: [
        {
          required: true,
          message: "Please input insurance name",
          trigger: ["blur", "change"],
        },
      ],
      policy_number: [
        {
          required: true,
          message: "Please input insurance Policy No.",
          trigger: ["blur", "change"],
        },
      ],

      contact_phone: [
        {
          required: false,
          message: "Please input phone number",
          trigger: ["blur", "change"],
        },
      ],
      contact_address: [
        {
          required: false,
          message: "Please input contact address",
          trigger: ["blur", "change"],
        },
      ],

      description: [
        {
          required: false,
          message: "Please input a description",
          trigger: ["blur", "change"],
        },
      ],
    });

    const submitForm = async (formEl) => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          isLoading.value = true;

          const formData = new FormData();
          insuranceForm.restricted = insuranceForm.restricted ? 1 : 0;

          formData.append("name", insuranceForm.name);
          formData.append("contact_phone", insuranceForm.contact_phone);
          formData.append("contact_email", insuranceForm.contact_email);
          formData.append("contact_address", insuranceForm.contact_address);
          formData.append("description", insuranceForm.description);
          formData.append("policy_number", insuranceForm.policy_number);
          formData.append("status", insuranceForm.status);
          formData.append("restricted", insuranceForm.restricted);


          if (insuranceForm.id > 0) {
            updateInsurance(insuranceForm)
              .then((data) => {
                if (data.success) {
                  ElNotification({
                    title: "Success",
                    message: data.message,
                    type: "success",
                  });

                  emit("refresh-insurances");
                  emit("close-modal");
                } else {
                  if (data.errors) {
                    Object.values(data.errors).forEach((val) =>
                      ElNotification({
                        title: "Error",
                        message: val[0],
                        type: "error",
                      })
                    );
                  }
                  if (data.message) {
                    ElNotification({
                      title: "Error",
                      message: data.message,
                      type: "error",
                    });
                  }
                }
              })
              .catch((err) =>
                ElNotification({
                  title: "Error",
                  message: err.message,
                  type: "error",
                })
              )
              .finally(() => {
                isLoading.value = false;
              });
          } else {
            createInsurance(formData)
              .then((data) => {
                if (data.success) {
                  console.log(data);
                  ElNotification({
                    title: "Success",
                    message: data.message,
                    type: "success",
                  });
                  emit("insurance-created", data.data);
                  emit("refresh-insurances");
                  emit("close-modal");
                } else {
                  if (data.errors) {
                    Object.values(data.errors).forEach((val) =>
                      ElNotification({
                        title: "Error",
                        message: val[0],
                        type: "error",
                      })
                    );
                  }
                  if (data.message) {
                    ElNotification({
                      title: "Error",
                      message: data.message,
                      type: "error",
                    });
                  }
                }
              })
              .catch((err) =>
                ElNotification({
                  title: "Error",
                  message: err.message,
                  type: "error",
                })
              )
              .finally(() => {
                isLoading.value = false;
              });
          }
        } else {
          console.log("error submit!", fields);
        }
      });
    };
    return {
      submitForm,
      rules,
      insuranceForm,
      insuranceFormRef,
      isLoading,
      props,
    };
  },
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  background-color: #000000da;
}

.card {
  margin-top: 5%;
  outline: 0;
  border-radius: 7px;
  width: 450px;
  max-height: 520px;
  box-shadow: 0 10px 20px -8px rgba(0, 0, 0, 0.15);
}
.card-body {
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}

.card-header {
  border-bottom: 1px solid #e9ecef;
  padding: 1.2rem !important;
}
.card--footer {
  display: flex;
  justify-content: space-between;
  padding: 0 1.2rem 1.2rem 1.2rem !important;
}
.close {
  margin: 5% 0 0 10px;
  cursor: pointer;
  color: #fff;
  border: 2px solid #fff;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
}

input {
  border-radius: 6px;
}
</style>
